import { Constants } from '@pwc/pwc-deals-web-common';
import FourBlockNarrowRigth from '../../../assets/report-format-layouts/four-block-narrow-right.svg';
import FourBlock from '../../../assets/report-format-layouts/four-block.svg';
import OneColumnFullWith from '../../../assets/report-format-layouts/one-column-full-width.svg';
import OneColumnLarge from '../../../assets/report-format-layouts/one-column-large.svg';
import OneColumnMedium from '../../../assets/report-format-layouts/one-column-medium.svg';
import OneColumnSmall from '../../../assets/report-format-layouts/one-column-small.svg';
import SixBlock from '../../../assets/report-format-layouts/six-block.svg';
import StackedLargeBottom from '../../../assets/report-format-layouts/stacked-large-bottom.svg';
import StackedLargeTop from '../../../assets/report-format-layouts/stacked-large-top.svg';
import StackedMediumTop from '../../../assets/report-format-layouts/stacked-medium-top.svg';
import StackedTwoBlockBottom from '../../../assets/report-format-layouts/stacked-two-block-bottom.svg';
import StackedTwoBlockTop from '../../../assets/report-format-layouts/stacked-two-block-top.svg';
import StackedWithNarrowRightColumn from '../../../assets/report-format-layouts/stacked-with-narrow-right-column.svg';
import StachedWithRightColumn from '../../../assets/report-format-layouts/stacked-with-right-column.svg';
import ThreeColumn from '../../../assets/report-format-layouts/three-column.svg';
import ThreeStackedWithRightColumn from '../../../assets/report-format-layouts/three-stacked-with-right-column.svg';
import TwoColumn from '../../../assets/report-format-layouts/two-column.svg';
import TwoColumnExtraNarrowRight from '../../../assets/report-format-layouts/two-column-extra-narrow-right.svg';
import TwoColumnNarrowLeft from '../../../assets/report-format-layouts/two-column-narrow-left.svg';
import TwoColumnNarrowRight from '../../../assets/report-format-layouts/two-column-narrow-right.svg';
import TwoColumnTextOnly from '../../../assets/report-format-layouts/two-column-text-only.svg';
// KFA
import KfaSingle from '../../../assets/report-format-layouts/kfa-single.svg';
import KfaThreeStacked from '../../../assets/report-format-layouts/kfa-three-stacked.svg';
import KfaTop20Bottom80 from '../../../assets/report-format-layouts/kfa-two-top20-bottom80.svg';
import KfaTop60Bottom40 from '../../../assets/report-format-layouts/kfa-two-top60-bottom40.svg';
import KfaTop80bottom20 from '../../../assets/report-format-layouts/kfa-two-top80-bottom20.svg';

import CONSTANTS from '../../../../features/analyses/Freeform/FreeformAnalysisLayout/AddReportDataLayoutContainer/Constants';

export const LAYOUTS = [
  {
    id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN,
    type: CONSTANTS.COLUMN_TYPE.ONE,
    image: OneColumnFullWith,
    label: '',
    description: '',
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40,
    type: CONSTANTS.COLUMN_TYPE.ONE,
    image: OneColumnSmall,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60,
    type: CONSTANTS.COLUMN_TYPE.ONE,
    image: OneColumnMedium,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_80,
    type: CONSTANTS.COLUMN_TYPE.ONE,
    image: OneColumnLarge,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA,
    type: CONSTANTS.COLUMN_TYPE.ONE,
    image: TwoColumnTextOnly,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_40_1A_R_60_1A,
    type: CONSTANTS.COLUMN_TYPE.TWO,
    image: TwoColumnNarrowLeft,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A,
    type: CONSTANTS.COLUMN_TYPE.TWO,
    image: TwoColumnNarrowRight,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN,
    type: CONSTANTS.COLUMN_TYPE.TWO,
    image: TwoColumn,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A,
    type: CONSTANTS.COLUMN_TYPE.TWO,
    image: StackedMediumTop,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A,
    type: CONSTANTS.COLUMN_TYPE.TWO,
    image: StackedLargeTop,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A,
    type: CONSTANTS.COLUMN_TYPE.TWO,
    image: StackedLargeBottom,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_80_1A_R_20_1A,
    type: CONSTANTS.COLUMN_TYPE.TWO,
    image: TwoColumnExtraNarrowRight,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN,
    type: CONSTANTS.COLUMN_TYPE.THREE,
    image: ThreeColumn,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A,
    type: CONSTANTS.COLUMN_TYPE.THREE,
    image: StachedWithRightColumn,
  },

  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_2A_R_33_1A,
    type: CONSTANTS.COLUMN_TYPE.THREE,
    image: StackedWithNarrowRightColumn,
  },

  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_2A_B_50_1A,
    type: CONSTANTS.COLUMN_TYPE.THREE,
    image: StackedTwoBlockTop,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A,
    type: CONSTANTS.COLUMN_TYPE.THREE,
    image: StackedTwoBlockBottom,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_50_2A_50_2A,
    type: CONSTANTS.COLUMN_TYPE.FOUR,
    image: FourBlock,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_67_2A_33_2A,
    type: CONSTANTS.COLUMN_TYPE.FOUR,
    image: FourBlockNarrowRigth,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_3A_R_50_1A,
    type: CONSTANTS.COLUMN_TYPE.FOUR,
    image: ThreeStackedWithRightColumn,
  },
  {
    id: Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN_TWO_ROW,
    type: CONSTANTS.COLUMN_TYPE.FOUR,
    image: SixBlock,
  },
];

export const LAYOUTS_BY_TYPE = [
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN,
      type: CONSTANTS.COLUMN_TYPE.ONE,
      image: OneColumnFullWith,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_80,
      type: CONSTANTS.COLUMN_TYPE.ONE,
      image: OneColumnLarge,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60,
      type: CONSTANTS.COLUMN_TYPE.ONE,
      image: OneColumnMedium,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40,
      type: CONSTANTS.COLUMN_TYPE.ONE,
      image: OneColumnSmall,
    },
  ],
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA,
      type: CONSTANTS.COLUMN_TYPE.ONE,
      image: TwoColumnTextOnly,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: TwoColumn,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_40_1A_R_60_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: TwoColumnNarrowLeft,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: TwoColumnNarrowRight,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_80_1A_R_20_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: TwoColumnExtraNarrowRight,
    },
  ],
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: StackedLargeTop,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: StackedMediumTop,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: StackedLargeBottom,
    },
  ],
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: StachedWithRightColumn,
    },

    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_2A_R_33_1A,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: StackedWithNarrowRightColumn,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_3A_R_50_1A,
      type: CONSTANTS.COLUMN_TYPE.FOUR,
      image: ThreeStackedWithRightColumn,
    },
  ],
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_2A_B_50_1A,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: StackedTwoBlockTop,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: StackedTwoBlockBottom,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_50_2A_50_2A,
      type: CONSTANTS.COLUMN_TYPE.FOUR,
      image: FourBlock,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_67_2A_33_2A,
      type: CONSTANTS.COLUMN_TYPE.FOUR,
      image: FourBlockNarrowRigth,
    },
  ],
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: ThreeColumn,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN_TWO_ROW,
      type: CONSTANTS.COLUMN_TYPE.FOUR,
      image: SixBlock,
    },
  ],
];

export const TOPIC_LAYOUTS = [
  [
    {
      id: Constants.TOPIC_LAYOUT_TYPE.ONE_COLUMN.value,
      type: CONSTANTS.COLUMN_TYPE.ONE,
      image: OneColumnFullWith,
    },
  ],
  [
    {
      id: Constants.TOPIC_LAYOUT_TYPE.TWO_COLUMN.value,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: TwoColumn,
    },
    {
      id: Constants.TOPIC_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A.value,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: TwoColumnNarrowRight,
    },
    {
      id: Constants.TOPIC_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A.value,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: StackedMediumTop,
    },
    {
      id: Constants.TOPIC_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A.value,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: StackedLargeTop,
    },
  ],
  [
    {
      id: Constants.TOPIC_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A.value,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: StackedTwoBlockBottom,
    },
    {
      id: Constants.TOPIC_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A.value,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: StachedWithRightColumn,
    },
    {
      id: Constants.TOPIC_LAYOUT_TYPE.THREE_COLUMN.value,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: ThreeColumn,
    },
  ],
];

export const KFA_LAYOUTS = [
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN,
      type: CONSTANTS.COLUMN_TYPE.ONE,
      image: KfaSingle,
    },
  ],
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: KfaTop80bottom20,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: KfaTop60Bottom40,
    },
  ],
  [
    {
      id: Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A,
      type: CONSTANTS.COLUMN_TYPE.TWO,
      image: KfaTop20Bottom80,
    },
    {
      id: Constants.SECTION_LAYOUT_TYPE.THREE_ROWS,
      type: CONSTANTS.COLUMN_TYPE.THREE,
      image: KfaThreeStacked,
    },
  ],
];
